import { Button } from '~/components/component-library/Button'
import { type GroupIconActionProps } from '~/components/component-library/Group/types'

// flex-col so Button's self-start doesn't pin it to the top of the h-5 line
export const GroupIconAction = ({
  icon,
  label,
  ...props
}: GroupIconActionProps) => (
  <div className="flex h-5 flex-col justify-center">
    <Button
      {...props}
      variant="tertiary"
      size="small"
      prefix={icon}
      aria-label={label}
    />
  </div>
)
